import moment from "moment";

class Util {
    constructor() {
        this.flattenArray = this.flattenArray.bind(this);
    }

    getCurrentWeekEnding() {
        let m = moment();
        m.endOf("w");
        return m;
    }

    purifyTimepart(str) {
        const m = moment(str);
        m.hour(0);
        m.minute(0);
        m.second(0);
        return m.format("YYYY-MM-DDThh:mm:ss");
    }

    toHrmString(unit) {
        let hr = Math.floor(unit);
        let min = Math.round((unit - hr) * 60);
        return `${hr} hr(s) ${min} min(s)`;
    }

    toFullHrmString(unit) {
        let hr = Math.floor(unit);
        let min = Math.round((unit - hr) * 60);
        return `${hr} hour(s) ${min} minute(s)`;
    }

    toShortHmString(unit) {
        let hr = Math.floor(unit);
        let min = Math.round((unit - hr) * 60);
        return `${hr}h ${min}m`;
    }
    getDailyHoursTextMiscAdd(workDate, hours) {
        let date = moment(workDate).format("MM/DD/YYYY");
        let hrs = hours ? hours : "8";
        return `The amount of daily hours input must be based on your regular number of hours worked in a day. Your work scheduled hours of ${date} is ${hrs} hours.`
    }

    hmStringToUnit(str) {
        str = str.trim();
        if (/^(\d+h)?\s*\d+m$/.test(str)) {
            let mReg = /(\d+)m/;
            let min = 0, hour = 0;
            if (mReg.test(str)) {
                let matches = mReg.exec(str);
                min = parseFloat(matches[1]);
            }

            let hReg = /(\d+)h/;
            if (hReg.test(str)) {
                let matches = hReg.exec(str);
                hour = parseFloat(matches[1]);
            }

            let result = hour + min / 60;
            return result;
        } else if (/^(\d+)(\.\d+)?h?$/.test(str)) {
            return parseFloat(str.trim());
        }

        return 0;
    }

    dayListFromWeekEnding(we) {
        const result = [];
        if (we) {
            let m = moment(we);
            m.add(-6, "d"); // Sun
            result.push(m.format("YYYY-MM-DDThh:mm:ss"));
            for (let i = 0; i < 6; i++) {
                m.add(1, "d");
                result.push(m.format("YYYY-MM-DDThh:mm:ss"));
            }
        }
        return result;
    }

    convertTo24h(hm, ampm) {
        const hmReg = /^(\d+):(\d+)$/;
        ampm = ampm.toLowerCase();

        if (hmReg.test(hm)) {
            const matches = hmReg.exec(hm);
            let h = parseInt(matches[1]);
            let m = parseInt(matches[2]);
            if (h > 12 || m > 60) return null;

            if (ampm === "am") {
                if (h == 12) h = 0;
            } else if (ampm == "pm") {
                if (h == 0) return null;
                if (h < 12) h += 12;
            } else {
                return null;
            }

            return `${h < 10 ? "0" + h : h}:${m < 10 ? "0" + m : m}`;
        }

        return null;
    }

    convertToAMPM(s) {
        const hmReg = /^(\d+):(\d+)$/;

        if (hmReg.test(s)) {
            const matches = hmReg.exec(s);
            let h = parseInt(matches[1]);
            let m = parseInt(matches[2]);
            let ampm = "AM";
            if (h > 23 || m > 60) return null;

            if (h == 0) {
                h = 12
            } else if (h == 12) {
                ampm = "PM"
            } else if (h > 12) {
                ampm = "PM";
                h = h - 12;
            }

            return `${h}:${m < 10 ? "0" + m : m} ${ampm}`;
        }

        return null;
    }

    fromalizeTimeText(text) {
        text = text.trim();
        text = text.replace(".", ":");

        if (/^\d+$/.test(text)) {
            text = `${text}:00`;
        }
        return text;
    }

    decomposeAMPM(s) {
        const hmReg = /^(\d+):(\d+) (AM|PM|am|pm)$/;

        if (hmReg.test(s)) {
            const matches = hmReg.exec(s);
            return {
                time: `${matches[1]}:${matches[2]}`,
                ampm: matches[3].toUpperCase()
            };
        }

        return null;
    }

    isInteger(value, allowBlank) {
        if (allowBlank == true && value == '')
            return true;

        var reg = new RegExp('^[0-9]+$');

        return reg.test(value);
    }

    isDecimal(value, wholeLength, decimalLength, allowBlank) {
        if (allowBlank == true && (value == '' || value == null))
            return true;

        var pattern = "(^(\\d{1,wholeLength})(\\.\\d{0,decimalLength})?$)|(^\\.(\\d{1,decimalLength})?$)"
        pattern = pattern.replace(/wholeLength/g, wholeLength);
        pattern = pattern.replace(/decimalLength/g, decimalLength);
        var reg = new RegExp(pattern);

        return reg.test(value);
    }

    isMMDDYYYY(value, allowBlank) {
        if (allowBlank == true && (value == '' || value == null)) {
            return true;
        }

        var reg = new RegExp('(^(0[1-9]|1[012])/(0[1-9]|[12][0-9]|3[01])/\\d{0,4}$)');

        return reg.test(value)
    }

    isTime(value, allowBlank) {
        if (allowBlank == true && (value == '' || value == null))
            return true;

        var reg = new RegExp('(^(0[0-9]|1[012]|[0-9])$)|(^(0[0-9]|1[012]|[0-9])[:\\.]$)|(^(0[0-9]|1[012]|[0-9])[:\\.]([0-5]|0[0-9]|[1234][0-9]|5[0-9])$)');

        return reg.test(value);
    }

    isValidTime(value) {
        if (value == '' || value == null)
            return false;

        var reg = new RegExp('(^(0[0-9]|1[012]|[0-9])[:\\.]([0-5]|0[0-9]|[1234][0-9]|5[0-9])$)');

        return reg.test(value);
    }

    newGuid() {
        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    }

    isEmail(value) {
        var reg = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
        return reg.test(value);
    }

    isPasswordValid(password) {
        var reg = new RegExp(/^(?=.*\d)(?=.*[~`!@#\$%\^&\*\[\]"\';:_\-<>\., =\+\/\\])(?=.*[a-z])(?=.*[A-Z]).{8,20}$/);
        return reg.test(password);
    }

    getQueryStringValue(key) {
        var values = window.location.href.split('?')

        if (values.length > 0) {
            var qValues = decodeURIComponent(values[1]).split('&')

            for (var i = 0; i < qValues.length; i++) {
                return qValues[i].substring((key + '=').length, qValues[i].length);
            }
        }

        return '';
    }

    /**
     * 
     * @param {String} tmpl 
     * @param {Object} map 
     * 
     * @returns {String}
     */
    populate(tmpl, map, wrapStart = '[', wrapEnd = ']') {
        const isNullOrUndefined = (obj) => {
            return obj === null || obj === undefined;
        };

        if (isNullOrUndefined(tmpl) || isNullOrUndefined(map)) return tmpl;

        let result = "";
        let i = 0;
        let start = 0;
        while (i < tmpl.length) {
            while (i < tmpl.length && tmpl[i] !== wrapStart) i++;

            result += tmpl.substring(start, i);
            start = i;
            i++;
            while (i < tmpl.length && tmpl[i] !== wrapEnd) i++;

            if (i < tmpl.length) {
                const key = tmpl.substring(start, i + 1);

                if (map[key] != null && map[key] != undefined) result += map[key];
                else result += key;

                i++;
                start = i;
            } else {
                result += tmpl.substring(start, i);
            }
        }

        return result;
    }

    getValueFromString(queryString, key) {
        var values = queryString.split('?')

        if (values.length > 0) {
            var qValues = decodeURIComponent(values[1]).split('&')

            for (var i = 0; i < qValues.length; i++) {
                return qValues[i].substring((key + '=').length, qValues[i].length);
            }
        }

        return '';
    }

    getDateToday() {
        return new Date(new Date().setHours(0, 0, 0, 0));
    }

    isStringNullOrEmpty(value) {
        if (value === undefined)
            return true;

        if (value == null)
            return true;

        if (value.toString().trim() == '')
            return true;

        return false;
    }

    countWeekending(dateStart, dateEnd) {
        let cnt = 0;
        let dStart = moment(dateStart);
        let dEnd = moment(dateEnd);

        while (dStart.isSameOrBefore(dEnd)) {
            if (dStart.day() == 6)
                cnt++;
            dStart.add(1, "day");
        }

        if (dEnd.day() < 6)
            cnt++;

        return cnt;
    }

    isIE() {
        const userAgent = navigator.userAgent.toLowerCase();
        return userAgent.indexOf("trident") > -1 || userAgent.indexOf("msie") > -1;
    }

    /**
     * @return {{ startDate: import("moment").Moment, endDate: import("moment").Moment }}
     */
    getCurrentWeekRange() {
        const now = moment();
        return this.getWeekRangeOf(now);
    }

    /**
     * @return {{ startDate: import("moment").Moment, endDate: import("moment").Moment }}
     */
    getWeekRangeOf(d) {
        const m = moment(d);
        return {
            startDate: moment(m.startOf("week")),
            endDate: moment(m.endOf("week"))
        }
    }

    /**
     * @return {{ startDate: import("moment").Moment, endDate: import("moment").Moment }}
     */
    getMonthRangeOf(d) {
        const m = moment(d);
        return {
            startDate: moment(m.startOf("month")),
            endDate: moment(m.endOf("month"))
        }
    }

    /**
     * 
     * @param {import("moment").Moment} startDate 
     * @param {import("moment").Moment} endDate 
     */
    getAllDaysInRange(startDate, endDate) {
        let s = moment(startDate);
        let e = moment(endDate);

        if (e.isBefore(s)) {
            tmp = e;
            e = s;
            s = tmp;
        }

        const cur = moment(s);
        const result = [];

        while (cur.isSameOrBefore(e)) {
            result.push(moment(cur));
            cur.add(1, "day");
        }

        return result;
    }

    /**
     * Source https://github.com/PimpTrizkit/PJs/wiki/12.-Shade,-Blend-and-Convert-a-Web-Color-(pSBC.js) 
     * @param {*} p 
     * @param {*} c0 
     * @param {*} c1 
     * @param {*} l 
     * @returns 
     */
    pSBC(p, c0, c1, l) {
        const pSBCr = (d) => {
            const i = parseInt;
            let n = d.length, x = {};
            if (n > 9) {
                const [r, g, b, a] = (d = d.split(','));
                n = d.length;
                if (n < 3 || n > 4) return null;
                x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1
            } else {
                if (n == 8 || n == 6 || n < 4) return null;
                if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
                d = i(d.slice(1), 16);
                if (n == 9 || n == 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = Math.round((d & 255) / 0.255) / 1000;
                else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1
            } return x
        };

        let r, g, b, P, f, t, h, m = Math.round, a = typeof (c1) == "string";
        if (typeof (p) != "number" || p < -1 || p > 1 || typeof (c0) != "string" || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a)) return null;
        h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = pSBCr(c0), P = p < 0, t = c1 && c1 != "c" ? pSBCr(c1) : P ? { r: 0, g: 0, b: 0, a: -1 } : { r: 255, g: 255, b: 255, a: -1 }, p = P ? p * -1 : p, P = 1 - p;
        if (!f || !t) return null;
        if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
        else r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5), g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5), b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5);
        a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
        if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
        else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2)
    }

    /**
    * Get text color in black or white in the contrast with background color
    * The implementation follows the suggestion of Web Content Accessibility Guidelines (WCAG) 2.0 https://www.w3.org/TR/WCAG20/
    * @param {string} bgColor
    */
    getBWContrastColor(bgColor) {
        let foreColor = "#000000";
        if (!bgColor || bgColor.length === 0) return foreColor;

        // Clean bgColor, coerce it into hex string of 6
        if (bgColor[0] === "#") bgColor = bgColor.substr(1);
        if (bgColor.length === 3) bgColor = bgColor[0] + bgColor[0] + bgColor[1] + bgColor[1] + bgColor[2] + bgColor[2];

        // Check if the length is 6, otherwise, throw error
        if (bgColor.length != 6) throw new Error("Calendar: invalid color string");


        const r = calcComponent(parseInt(bgColor.substr(0, 2), 16) / 255);
        const g = calcComponent(parseInt(bgColor.substr(2, 2), 16) / 255);
        const b = calcComponent(parseInt(bgColor.substr(4, 2), 16) / 255);

        // Calculate relative luminance of the color (**)
        const L = 0.2126 * r + 0.7152 * g + 0.0722 * b;

        // Cache result into _foreColor attribute
        foreColor = (L + 0.05) / (0.0 + 0.05) > (1.0 + 0.05) / (L + 0.05) ? "#000000" : "#FFFFFF";

        return foreColor;

        /**
        * Calculate R/G/B component for formula (**)
        * @param {any} component
        */
        function calcComponent(component) {
            return component <= 0.03928 ? component / 12.92 : Math.pow((component + 0.055) / 1.055, 2.4);
        }
    }

    flattenArray(arr) {
        let result = [];
        for (const item of arr) {
            if (Array.isArray(item)) {
                result = [...result, ...(this.flattenArray(item))]
            } else {
                result.push(item);
            }
        }
        return result;
    }

    isMobile() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1 || ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }
}


const util = new Util();
export default util;
